import { CheckoutType } from "@/types";
export const checkoutBasePaths = {
    [CheckoutType.internet]: "/dsl-und-internet",
    [CheckoutType.streaming]: "/waipu",
    [CheckoutType.simOnly]: "/tarife",
};
